import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';

interface TaskAssignmentButtonProps {
  taskId: string;
  currentAssignee?: string;
  onAssignmentChange?: (taskId: string, newAssignee: string | null) => void;
}

/**
 * TaskAssignmentButton — assign/unassign the current user on a task.
 *
 * STUB: Backend PUT /api/tasks/{id} returns 501. The click handler shows an
 * inline "coming soon" message instead of calling the API. Wire up
 * apiUpdateTask once the endpoint is migrated (Phase X).
 *
 * TODO: replace stub body with:
 *   const newAssignee = isAssignedToMe ? null : (user?.name ?? null);
 *   await apiUpdateTask(taskId, { agent_name: newAssignee });
 *   onAssignmentChange?.(taskId, newAssignee);
 */
export function TaskAssignmentButton({
  taskId,
  currentAssignee,
  onAssignmentChange,
}: TaskAssignmentButtonProps) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [stubMessage, setStubMessage] = useState('');

  const isAssignedToMe = currentAssignee === user?.name;

  const handleClick = async () => {
    // Stub: backend not ready yet (501). Show inline notice.
    setStubMessage('Task assignment is not yet available.');
    setTimeout(() => setStubMessage(''), 2500);

    // TODO (Phase X): implement when backend PUT /api/tasks/{id} is migrated
    // setLoading(true);
    // try {
    //   const newAssignee = isAssignedToMe ? null : (user?.name ?? null);
    //   await apiUpdateTask(taskId, { agent_name: newAssignee });
    //   onAssignmentChange?.(taskId, newAssignee);
    // } catch (err: any) {
    //   if (err.response?.status === 501) {
    //     setStubMessage('Task assignment is not yet available.');
    //     setTimeout(() => setStubMessage(''), 2500);
    //   }
    // } finally {
    //   setLoading(false);
    // }
  };

  return (
    <div className="flex flex-col items-start gap-1">
      <button
        onClick={handleClick}
        disabled={loading}
        className="px-3 py-1.5 text-xs font-medium rounded-lg transition-all disabled:opacity-60 active:scale-95"
        style={{
          backgroundColor: isAssignedToMe ? '#10b981' : '#e5e7eb',
          color: isAssignedToMe ? 'white' : '#374151',
        }}
        title="Task assignment coming soon"
        data-testid={`assign-button-${taskId}`}
      >
        {loading ? 'Updating...' : isAssignedToMe ? 'Unassign' : 'Assign to me'}
      </button>
      {stubMessage && (
        <span className="text-[10px] text-amber-600 font-medium" data-testid={`assign-stub-${taskId}`}>
          {stubMessage}
        </span>
      )}
    </div>
  );
}
